const pulse = 'animate-pulse rounded-2xl bg-gray-200/80'

export const HomeSkeleton = () => (
  <div className="flex flex-col gap-3" aria-busy aria-label="Carregando início">
    <div className={`${pulse} h-[260px]`} />
    <div className={`${pulse} h-[220px]`} />
    <div className={`${pulse} h-[180px]`} />
  </div>
)
